import React, { useContext, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import myFunctions from '../../../myFunctions';
import { CurrentSingleContext } from '../../MyContexts/CurrentSingle_Context';
import { RestContext } from '../../MyContexts/Rest_Context';
import SelectImgComp from '../../MySections/ImagesSetter/SelectImgComp';
import SelectImgDelay from '../../MySections/ImagesSetter/SelectImgDelay';
import RichTextComp from '../../MySections/TextEditor/RichText';

const SectItmmainHeadEffects = (props) => {
    const [currentSingle, setCurrentSingle] = useContext(CurrentSingleContext);


    const [mainHeadColor, setMainHeadColor] = useState(currentSingle.mainHeadColor);
    const [mainHeadEffect, setMainHeadEffect] = useState(currentSingle.mainHeadEffect);
    const [mainHeadduration, setMainHeadduration] = useState(currentSingle.mainHeadduration);
    const [mainHeaddelay, setMainHeaddelay] = useState(currentSingle.mainHeaddelay);


    useEffect(() => {

    }, [])
    return (
        <div className={"col-md-3 mb-2 onRight"}>
            <div className={"col-md-6 mb-2 onRight"}>
                <label>צבע טקסט</label>
                <div className={"input-group"}>
                    <input type={"text"} className={"form-control"} id={"validationCustom02"} placeholder={"#fffff"} value={mainHeadColor} style={{ direction: "ltr" }}
                        onChange={(e) => {currentSingle.mainHeadColor = e.target.value; setMainHeadColor(e.target.value) }} required />

                </div>
            </div>
            <div className={"col-md-6 mb-2 onRight"}>
                <label>אפקט</label>
                <div className={"input-group"}>
                    <select defaultValue={mainHeadEffect} style={{ direction: "ltr" }}
                        onChange={(e) => {currentSingle.mainHeadEffect = e.target.value; setMainHeadEffect(e.target.value) }}>

                        {myFunctions.animateList().map((itm, indx) => {
                            return (
                                <option key={indx}>
                                    {itm}
                                </option>
                            )
                        })}
                    </select>
                </div>
            </div>

            <div className={"col-md-6 mb-2 onRight"}>
                <label>Duration (0-5)</label>
                <div className={"input-group"}>
                    <input type={"number"} max={5} min={0} className={"form-control"} id={"validationCustom02"} placeholder={""}
                        value={mainHeadduration} style={{ direction: "ltr" }}
                        onChange={(e) => {currentSingle.mainHeadduration = e.target.value; setMainHeadduration(e.target.value) }} />

                </div>
            </div>
            <div className={"col-md-6 mb-2 onRight"}>
                <label>Delay</label>
                <div className={"input-group"}>
                    <SelectImgDelay currentDelay={mainHeaddelay ? mainHeaddelay : ""}
                        theFunction={(fUrl) => {currentSingle.mainHeaddelay = fUrl; setMainHeaddelay(fUrl) }} />

                </div>
            </div>
        </div >


    );
}

export default SectItmmainHeadEffects;